function SetupIosPrompt() {
  var alert = $(".ios-prompt");
  var currentLink = alert.attr("data-currentlink");

  // on click of the close button
  alert.find(".ios-prompt__close").on("click", function (evt) {
    // animate the panel away
    alert.slideToggle("slow");

    // tell silverstripe to hide this panel
    $.ajax({
      url: currentLink,
      type: "POST",
      data: {},
      response: function (response) {
        // console.log(response);
      },
    });
  });
}

$(document).ready(function () {
  if ($(".ios-prompt").length > 0) {
    if (!window.navigator.standalone) {
      SetupIosPrompt();
    } else {
      $(".ios-prompt").remove();
    }
  }
});
